import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'connection',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: { id },
  }
}
